import { IPoint } from "../interfaces/IPoint";

export class Workarea {
	public points: IPoint[] = [];
	public width: number;
	public height: number;
}